(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeBuyNow = () => {
      document.querySelectorAll('[data-buy-now]').forEach((button) => {
        if (button.dataset.buyNowInitialized === 'true') {
          return;
        }

        button.dataset.buyNowInitialized = 'true';

        button.addEventListener('click', async () => {
          const form = button.closest('form[data-type="add-to-cart-form"]');

          if (!form) {
            return;
          }

          const variantInput = form.querySelector('input[name="id"]');
          const quantityInput = form.querySelector('input[name="quantity"]');

          const variantId = Number(variantInput?.value);
          const quantity = Math.max(1, Number(quantityInput?.value) || 1);

          if (!variantId) {
            return;
          }

          const originalText = button.textContent.trim();

          button.disabled = true;
          button.textContent = 'Processing...';

          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity: quantity
                  }
                ]
              })
            });

            if (!response.ok) {
              throw new Error(`Cart add failed: ${response.status}`);
            }

            window.location.assign('/checkout');
          } catch (error) {
            console.error('Buy now failed:', error);
            button.disabled = false;
            button.textContent = originalText;
          }
        });
      });
    };

    initializeBuyNow();

    document.addEventListener('shopify:section:load', initializeBuyNow);
    document.addEventListener('shopify:block:select', initializeBuyNow);
  })();
  } catch(e) { console.error(e); }
})();

})();
